import { AvatarSize } from './types'

export const AVATAR_SIZES: Record<AvatarSize, number> = {
  [AvatarSize._4XS]: 20,
  [AvatarSize._3XS]: 24,
  [AvatarSize._2XS]: 28,
  [AvatarSize.XS]: 32,
  [AvatarSize.SM]: 40,
  [AvatarSize.MD]: 48,
  [AvatarSize.LG]: 56,
  [AvatarSize.XL]: 64,
  [AvatarSize._2XL]: 80,
  [AvatarSize._3XL]: 100,
  [AvatarSize._4XL]: 140,
}

export const AVATAR_WITH_STORY_INNER_SIZES: Record<AvatarSize, number> = {
  [AvatarSize._4XS]: AVATAR_SIZES[AvatarSize._4XS] - 3,
  [AvatarSize._3XS]: AVATAR_SIZES[AvatarSize._3XS] - 4,
  [AvatarSize._2XS]: AVATAR_SIZES[AvatarSize._2XS] - 4,
  [AvatarSize.XS]: AVATAR_SIZES[AvatarSize.XS] - 7,
  [AvatarSize.SM]: 34,
  [AvatarSize.MD]: AVATAR_SIZES[AvatarSize.MD] - 8,
  [AvatarSize.LG]: 48,
  [AvatarSize.XL]: 56,
  [AvatarSize._2XL]: AVATAR_SIZES[AvatarSize._2XL] - 10,
  [AvatarSize._3XL]: AVATAR_SIZES[AvatarSize._3XL] - 10,
  [AvatarSize._4XL]: AVATAR_SIZES[AvatarSize._4XL] - 10,
}

export const AVATAR_STROKE_WIDTHS: Record<AvatarSize, number> = {
  [AvatarSize._4XS]: 1,
  [AvatarSize._3XS]: 1.1,
  [AvatarSize._2XS]: 1.2,
  [AvatarSize.XS]: 1.3,
  [AvatarSize.SM]: 1.5,
  [AvatarSize.MD]: 1.7,
  [AvatarSize.LG]: 2,
  [AvatarSize.XL]: 2,
  [AvatarSize._2XL]: 3,
  [AvatarSize._3XL]: 3,
  [AvatarSize._4XL]: 3,
}
